import React from "react";

import { Link } from "react-scroll";
import { FaInstagram, FaFacebookSquare, FaLinkedin } from "react-icons/fa";
import Logo from "../../assets/images/furafilla_logo.png";
import StonePartnership from "../../assets/images/stone-partner-logo.png";
import {
  Section,
  Container,
  IconContainer,
  LinkContainer,
  PartnershipContainer,
  ClickableIcon
} from "./styles.css";

export default function Footer() {
  return (
    <Section>
      <Container>
        <Link to="sec-one" smooth offset={-70} duration={500}>
          <img src={Logo} alt="" />
        </Link>
        <LinkContainer>
          <Link to="sec-two" smooth offset={-70} duration={500}>
            <span>Como funciona</span>
          </Link>
          <Link to="sec-three" smooth offset={-70} duration={500}>
            <span>Vantagens</span>
          </Link>
          <Link to="sec-four" smooth offset={-70} duration={500}>
            <span>Quem somos</span>
          </Link>
          <Link to="sec-five" smooth offset={-70} duration={500}>
            <span>Contato</span>
          </Link>
        </LinkContainer>
        <IconContainer>
          <ClickableIcon
            target="_blank"
            rel="noopener noreferrer"
            href="https://www.facebook.com/furafilla"
          >
            <FaFacebookSquare color="#fff" size="2em" />
          </ClickableIcon>
          <ClickableIcon
            target="_blank"
            rel="noopener noreferrer"
            href="https://www.instagram.com/furafilla.app/"
          >
            <FaInstagram color="#fff" size="2em" />
          </ClickableIcon>
          <ClickableIcon
            target="_blank"
            rel="noopener noreferrer"
            href="https://www.linkedin.com/company/furafillaapp/"
          >
            <FaLinkedin color="#fff" size="2em" />
          </ClickableIcon>
        </IconContainer>
      </Container>
      <PartnershipContainer>
        <img
          src={StonePartnership}
          alt="Selo de Parceria Oficial com a Stone"
        />
      </PartnershipContainer>
    </Section>
  );
}
